module.exports = __webpack_public_path__ + "static/media/m-cover-prescription.60038d3f.png";